module.exports = __webpack_public_path__ + "img/manualUbi.213df77c.png";